import { InjectionToken } from '@angular/core';
import {
  ShareableLabel,
  ShareableType,
} from '@bindoc-projects/resource-domain-lib';
import { Observable } from 'rxjs';

export interface BdEditLabelsRequest {
  shareableType: ShareableType;
  shareableId: string;
  shareableName?: string;
}

/**
 * Opens the labels-edit dialog and emits exactly once:
 *  - the new label list when the user saved (possibly empty),
 *  - `null` when the dialog was cancelled or closed without saving.
 *
 * The implementation lives in the secondary `@bindoc-projects/resource-lib/registration`
 * entrypoint so that apps that don't need the AutoComplete-heavy dialog don't
 * pull it into their eager bundle. Apps that need it should provide the token
 * via `provideEditLabelsDialog()` (also exported from `@bindoc-projects/resource-lib/registration`).
 */
export type BdEditLabelsOpener = (
  request: BdEditLabelsRequest,
) => Observable<ShareableLabel[] | null>;

export const BD_EDIT_LABELS_OPENER = new InjectionToken<BdEditLabelsOpener>(
  'BD_EDIT_LABELS_OPENER',
);
